/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationHistoryPage } from './ConfigurationHistoryPage';
import {
    ConfigurationHistoryPageFromJSON,
    ConfigurationHistoryPageFromJSONTyped,
    ConfigurationHistoryPageToJSON,
    ConfigurationHistoryPageToJSONTyped,
} from './ConfigurationHistoryPage';

/**
 * 
 * @export
 * @interface FindConfigurationHistory200Response
 */
export interface FindConfigurationHistory200Response {
    /**
     * 
     */
    data?: ConfigurationHistoryPage;
}

/**
 * Check if a given object implements the FindConfigurationHistory200Response interface.
 */
export function instanceOfFindConfigurationHistory200Response(value: object): value is FindConfigurationHistory200Response {
    return true;
}

export function FindConfigurationHistory200ResponseFromJSON(json: any): FindConfigurationHistory200Response {
    return FindConfigurationHistory200ResponseFromJSONTyped(json, false);
}

export function FindConfigurationHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindConfigurationHistory200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ConfigurationHistoryPageFromJSON(json['data']),
    };
}

export function FindConfigurationHistory200ResponseToJSON(json: any): FindConfigurationHistory200Response {
    return FindConfigurationHistory200ResponseToJSONTyped(json, false);
}

export function FindConfigurationHistory200ResponseToJSONTyped(value?: FindConfigurationHistory200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ConfigurationHistoryPageToJSON(value['data']),
    };
}

